import { Observable, Subject, takeUntil, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { Injectable, OnDestroy } from '@angular/core';
import {
  HttpClient,
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Router } from '@angular/router';
import { CookieCustomService } from '../services/cookie.custom.service';
import { DeleteCookiesLoading } from '../store/auth/auth.actions';
import {
  DeleteCookiesLoadingAdmin,
  logoutAdmin,
} from '../store/auth-admin/auth-admin.actions';
import { Store } from '@ngrx/store';
import { selectGoodModeType } from '../store/goodmode/goodmode.selectors';
import { UserRolesEnum } from '../interfaces/user.interface';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor, OnDestroy {
  userType: UserRolesEnum = UserRolesEnum.receiver;
  destroySubject$: Subject<void> = new Subject();
  constructor(
    private http: HttpClient,
    private router: Router,
    private localStorage: CookieCustomService,
    private store: Store
  ) {
    this.store
      .select(selectGoodModeType)
      .pipe(takeUntil(this.destroySubject$))
      .subscribe(type => {
        if (type) {
          this.userType = type;
        }
      });
  }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      tap(),
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          if (this.userType === UserRolesEnum.receiver) {
            this.logout();
          }
          if (this.userType === UserRolesEnum.admin) {
            this.logoutAdmin();
          }
        }
        return throwError(() => error);
      })
    );
  }

  logout(): void {
    this.store.dispatch(DeleteCookiesLoading({}));
  }

  logoutAdmin(): void {
    this.store.dispatch(DeleteCookiesLoadingAdmin());
  }

  ngOnDestroy(): void {
    this.destroySubject$.next();
    this.destroySubject$.unsubscribe();
  }
}
